import React, { useState, useEffect } from "react";
import 'antd/dist/antd.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import './stylesheets/global.scss';
import Loading from './Loading';
import { getOrganizationCodes, getAccountEmailCheck } from "./apis/RegistrationApis";

const Registration = React.lazy(() => import('./Register'));
const SpecialNeedsRegistrations = React.lazy(() => import('./SpecialNeedsRegistrations'));
function OrgCodeRoute({ orgCode, ...props }) {
  const [apiMessage, setApiMessage] = useState(null);

  useEffect(() => {
    if (orgCode === undefined || orgCode === null) return;
    let mounted = true;
    const payload = {
      entityData: { 
        invitationCode: isNaN(Number(orgCode)) ? orgCode : Number(orgCode) 
      }
    };

    (async () => {
      try {
        const res = await getAccountEmailCheck(payload);
        if (!mounted) return;
        const message = res?.data?.message ?? res?.message ?? null;
        setApiMessage(message);
        console.log('API result for', orgCode, res);
      } catch (err) {
        if (!mounted) return;
        console.error('getAccountEmailCheck error', err);
        setApiMessage(null);
      }
    })();

    return () => { mounted = false; };
  }, [orgCode]);

  return <SpecialNeedsRegistrations {...props} orgCode={orgCode} apiMessage={apiMessage} />;
}

function App() {
  const [orgCodes, setOrgCodes] = useState([]);
  const getOrgCodes = async () => {
    const res = await getOrganizationCodes();
    const codes = Array.isArray(res?.data)
      ? res.data
      : Array.isArray(res)
      ? res
      : [];
    setOrgCodes(
      codes.map((c) => typeof c === "string" ? c : c?.code || c?.invitationCode || c?.orgCode)
        .filter(Boolean)
        .map(String)
        .map((s) => s.trim())
    );
    return res;
  };

  useEffect(() => {
    getOrgCodes();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <React.Suspense fallback={<Loading loadingStatus={true} />}>
          <Switch>
            <Route path="/soct" name="Home" render={(props) => <Registration {...props} />} />
            <Route exact path="/9131" name="Registration" render={(props) => <SpecialNeedsRegistrations {...props} />} />
            {orgCodes.map(code => (
              <Route
                key={code}
                exact
                name="OrgRegistration"
                path={`/${code}`}
                render={(props) => <OrgCodeRoute {...props} orgCode={code} />}
              />
            ))}
          </Switch>
        </React.Suspense>
      </BrowserRouter>
     
    </div>
  );
}

export default App;
